import { createAction } from "@reduxjs/toolkit";
import { amRoutes, externalLinks, ucEndpoints } from "../../config/config";
import { delayBeforeRedirect } from "../../config/constants";
import { showSuccessMessage } from "../../store/statusMessages";
import { getErrorMessageFromRequest } from "../../utils/utils";
import { apiCallBegan } from "../middlwares/api";
import { setShortToken } from "../users/users";
import * as actionTypes from "./actionTypes";

export const setRegistrationToken = createAction(actionTypes.SET_REGISTRATION_TOKEN);
export const registerUserStart = createAction(actionTypes.REGISTER_USER_START);
export const registerUserSuccess = createAction(actionTypes.REGISTER_USER_SUCCESS);
export const registerUserFailure = createAction(actionTypes.REGISTER_USER_FAILURE);
export const checkRegistrationTokenStart = createAction(actionTypes.REGISTRATION_TOKEN_CHECK_START);
export const checkRegistrationTokenSuccess = createAction(
  actionTypes.REGISTRATION_TOKEN_CHECK_SUCCESS
);
export const checkRegistrationTokenFailure = createAction(
  actionTypes.REGISTRATION_TOKEN_CHECK_FAILURE
);
export const userRegistrationConfirmStart = createAction(
  actionTypes.USER_REGISTRATION_CONFIRM_START
);
export const userRegistrationConfirmSuccess = createAction(
  actionTypes.USER_REGISTRATION_CONFIRM_SUCCESS
);
export const userRegistrationConfirmFailure = createAction(
  actionTypes.USER_REGISTRATION_CONFIRM_FAILURE
);

export const checkRegistrationToken = registrationToken => dispatch => {
  dispatch(setRegistrationToken(registrationToken));
  dispatch(
    apiCallBegan({
      url: ucEndpoints.checkRegistration,
      method: "post",
      data: { registrationToken },
      onStart: checkRegistrationTokenStart,
      onSuccess: ({ registration, shortToken }) => dispatch => {
        dispatch(checkRegistrationTokenSuccess({ registration }));
        setShortToken(shortToken);
      },
      onFailure: error => dispatch =>
        dispatch(checkRegistrationTokenFailure(getErrorMessageFromRequest(error)))
    })
  );
};

export const registerAccount = values => dispatch =>
  dispatch(
    apiCallBegan({
      url: ucEndpoints.registerAccount,
      method: "post",
      data: { values },
      onStart: registerUserStart,
      onSuccess: () => dispatch => {
        dispatch(registerUserSuccess());
        dispatch(
          showSuccessMessage(
            "Your account has been created.",
            "Please check your email to finish your registration."
          )
        );
      },
      onFailure: error => dispatch =>
        dispatch(registerUserFailure(getErrorMessageFromRequest(error)))
    })
  );

export const confirmRegistration = registrationToken => dispatch =>
  dispatch(
    apiCallBegan({
      url: ucEndpoints.confirmRegistration,
      method: "post",
      data: registrationToken,
      onStart: () => dispatch => dispatch(userRegistrationConfirmStart()),
      onSuccess: ({ user, shortToken }) => dispatch => {
        dispatch(userRegistrationConfirmSuccess());
        setShortToken(shortToken);
        dispatch(showSuccessMessage("Registration successful!"));
        const system = user?.roles?.length > 0 && user.roles[0].system;
        return setTimeout(() => {
          window.location.href = system ? externalLinks[system] : amRoutes.login;
        }, delayBeforeRedirect);
      },
      onFailure: error => dispatch =>
        dispatch(userRegistrationConfirmFailure(getErrorMessageFromRequest(error)))
    })
  );
